import Cross from "../../../assets/icon/NewsIcons/MainAdmin/NewsCross"
import React, { useState } from "react";
import { axiosReq, axiosReq2 } from "../../../commons/axiosReq";
import { Link } from "react-router-dom";
import axios from "axios";
import { apiAssetSar, apiUrlSar } from "../../../commons/inFormTypes";

const DeleteModalSession = ({ setShowModal, title, buttonName, text, setRecheck, reCheck, data,id }) => {
    const [showErrorModalStep1,
        setShowErrorModalStep1] = useState(false);
    const deleteAdmin = async () => {

        // const dataUser = await axiosReq2("admin/rag_access", "delete", {
        //     user_id:id,
        //     rag_system_id:data?.id

        // });
          const dataUser = await axios.delete(apiUrlSar+'user/chat', {
      headers: {
        'accept': 'application/json',
        'Content-Type': 'application/json',
                                Authorization: `Bearer c2dffe2aa00a3f8b7d854279f4aaa1ff`,

      },
      data: {
        user_id: id,
        session_id:data?.id
      }
    });
        console.log(dataUser)
        if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
             
   setRecheck(!reCheck)
            setShowModal(false)
            alert("موفقیت آمیز");

        }
        else {
            console.log()

            setShowErrorModalStep1(true);
        }

    }
   
    return (
        <>
            <div
                className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
            >
                <div className="relative w-[30%] my-5 mx-auto ">

                    <div className="border-0 rounded-[20px] p-[25px] shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <div className="flex justify-between items-center border-b-2 pb-[25px] border-borderGray">
                            <p className="text-[15px] font-IRANYekanBold text-mainColor2">{title}</p>
                            <button onClick={() => setShowModal(false)}><Cross /></button>
                        </div>
                        <div className="flex justify-center items-center w-full mt-[23px] mb-[43px]">
                            <p className="font-IRANYekanBold text-[15px]">{text}</p>
                        </div>
                        <div className="flex justify-center">
                            <button onClick={() => setShowModal(false)}><p className="text-[15px] font-IRANYekanBold ml-[23px]">بستن</p></button>
                            <button onClick={() =>deleteAdmin()} className="h-[40px] w-[107px] bg-Orange2 rounded-[10px]"><p className="text-[15px] text-white font-IRANYekanBold">{buttonName}</p></button>
                        </div>
                    </div>
                </div>
                {showErrorModalStep1 ?
                    <>
                        <div
                            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                        >
                            <div className="relative w-[30%] lg:w-[50%] sm:w-[95%] my-5 mx-auto max-w-3xl">

                                <div className="border-0 rounded-lg p-2 shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">

                                    <div className="flex items-start justify-between p-4 border-b border-solid border-b-midGray rounded-t">
                                        <span className="text-base font-bold   text-red">
                                            درخواست اشتباه !
                                        </span>

                                    </div>

                                    <div className="relative px-4 py-1 flex-auto">
                                        <p className="my-4 text-black text-sm   leading-relaxed">
                                            لطفا اطلاعات خواسته شده را کامل وارد نمایید.
                                        </p>
                                    </div>

                                    <div className="flex  items-center  justify-end border-solid border-slate-200 rounded-b">
                                        <Link

                                            className="text-white  mx-4 mb-2  rounded-md shadow-blueShadow  bg-mainColor font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={() => setShowErrorModalStep1(false)}
                                        >
                                            فهمیدم
                                        </Link>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>

                    </>
                    : null
                }
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
    )
}

export default DeleteModalSession;